function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
var Radio = Controls.Radio;
var notNull = validators.notNull;
var styles = {
  wrapper: 'mb-3'
};
var BrazilPaymentMethodsRequirementForm = function BrazilPaymentMethodsRequirementForm(_ref) {
  var total = _ref.total;
  var userCountry = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user ? user.country : null;
  });
  var visible = userCountry === 'BR' && total > 0;
  var methods = useFormContext();
  var _methods$watch = methods.watch(['brazilPaymentMethods']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    brazilPaymentMethods = _methods$watch2[0];
  useEffect(function () {
    methods.resetField('paymentMethodId');
    methods.setValue('requestAllpago', false);
    methods.setValue('usingFapespFunds', false);
    if (brazilPaymentMethods === 'fapesp') {
      methods.setValue('usingFapespFunds', true);
      methods.setValue('creditCard.currency.value', 'USD');
    } else if (brazilPaymentMethods === 'allpago') {
      methods.setValue('requestAllpago', true);
    }
  }, [brazilPaymentMethods]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fapiao-requirement-form alert alert-info mt-0 mb-3"
  }, /*#__PURE__*/React.createElement(Radio, {
    label: "select-brazil-payment-options",
    messages: {
      notEmpty: 'You must select an option'
    },
    name: "brazilPaymentMethods",
    styles: styles,
    options: [{
      value: 'no-requirements',
      label: /*#__PURE__*/React.createElement(T, {
        source: "no-payment-requirements-response"
      })
    }, {
      value: 'fapesp',
      label: /*#__PURE__*/React.createElement(T, {
        source: "using-fapesp-funds-response"
      })
    }, {
      value: 'allpago',
      label: /*#__PURE__*/React.createElement(T, {
        source: "allpago-requirement-response"
      })
    }],
    defaultValue: {
      value: 'no-requirements'
    },
    validators: {
      notNull: notNull
    }
  }))));
};
export default BrazilPaymentMethodsRequirementForm;